import React from 'react';

type BoldIconProps = {
  height?: string;
  width?: string;
};

function SuperScriptx({ height = '18', width = '18' }: BoldIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.7686 8L6.46094 17M6.46094 8L14.7686 17'
        stroke='black'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M18.9101 8.68821H21.6572V9.81842H16.6172V9.49396C17.7204 8.28984 18.5171 7.39035 19.0074 6.7955C19.5013 6.20065 19.8276 5.75001 19.9862 5.44357C20.1484 5.13353 20.2295 4.82709 20.2295 4.52426C20.2295 4.1998 20.1268 3.93842 19.9213 3.74014C19.7194 3.54186 19.4526 3.44271 19.121 3.44271C18.7749 3.44271 18.4955 3.54546 18.2828 3.75095C18.0737 3.95284 17.9691 4.21602 17.9691 4.54048V4.70271H16.774V4.53508C16.774 3.87173 16.9885 3.33636 17.4175 2.92898C17.8465 2.51799 18.4107 2.3125 19.1101 2.3125C19.7951 2.3125 20.3539 2.5198 20.7865 2.93439C21.2192 3.34538 21.4355 3.87353 21.4355 4.51885C21.4355 4.86134 21.3742 5.19121 21.2516 5.50847C21.129 5.82572 20.8857 6.23671 20.5216 6.74143C20.1574 7.24254 19.6203 7.89147 18.9101 8.68821Z'
        fill='black'
      />
    </svg>
  );
}

export default SuperScriptx;
